import { useEffect } from 'react';

import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import {
	AnchorPageRelayQuery,
	shapeAnchorContentfulResponse,
} from 'src/contentful/graphql/anchor-page';

import { anchorPageRelayQuery } from '@/__generated_contentful__/anchorPageRelayQuery.graphql';
import { PaidLandingPersonaTypes } from '@/utils/anchor-queries/get-anchor-contents';
import { AnchorContentsResponse } from '@/utils/anchor-queries/get-anchor-contents';
import { experiments } from '@/utils/experiment/manifest';
import { useExperimentExposure } from '@/utils/experiment/use-experiment-exposure';

import { ConfluenceSoftwarePageProps } from './confluence-software-page';
import { ConfluencePagePaidLpConflAnchor } from './paid-lp-confl-anchor';
import { getPageId } from './subAnchors/subAnchor-util.tsx';

export interface ConfluencePageSubAnchorRelayProps extends ConfluenceSoftwarePageProps {
	anchorContents?: AnchorContentsResponse | null;
	queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const ConfluenceSoftwarePageVariantPaidLpConfSubAnchors = (
	pageProps: ConfluencePageSubAnchorRelayProps,
) => {
	const [exposureSubAnchorFired, fireSubAnchorExposure] = useExperimentExposure(
		experiments.cfind4782LandingPageSubAnchorV3,
	);

	useEffect(() => {
		if (!exposureSubAnchorFired) {
			fireSubAnchorExposure();
		}
	}, [exposureSubAnchorFired, fireSubAnchorExposure]);

	const data = usePreloadedQuery(
		AnchorPageRelayQuery,
		pageProps.queryRef || (null as unknown as PreloadedQuery<anchorPageRelayQuery>),
	);
	pageProps = Object.assign({}, pageProps, {
		anchorContents: shapeAnchorContentfulResponse(data),
	});

	return (
		<ConfluencePagePaidLpConflAnchor
			{...pageProps}
			pageId={getPageId(pageProps.subAnchor)}
			persona={'unknown' as PaidLandingPersonaTypes}
			pageVariant="subAnchor"
			dataProductKey="confluence-PaidLpConflSubAnchor"
		/>
	);
};
